<template>
    <div id="app">
        <router-view class="router-container" />
        <transition name="fade">
            <spinner-overlay v-show="isLoading" />
        </transition>
    </div>
</template>

<script>
import SpinnerOverlay from "@/components/SpinnerOverlay";
import { mapGetters } from "vuex";

export default {
    name: "app",
    components: {
        SpinnerOverlay
    },
    computed: {
        ...mapGetters(["isLoading"])
    }
};
</script>

<style lang="scss">
@import "./scss/base.scss";
@import "~../node_modules/vex-js/dist/css/vex.css";
@import "~../node_modules/vex-js/dist/css/vex-theme-plain.css";

body {
    display: block !important;
}

#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    color: $text-primary;
    height: 100%;
}

#nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
            color: #42b983;
        }
    }
}

#main-page {
    height: 100%;
}

.router-container {
    height: 100%;
    display: flex;
    flex-direction: column;
}
</style>
